<template>
  <div
    :id="modalId"
    class="modal fade logout-modal"
    tabindex="-1"
    :aria-labelledby="labelId"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered logout-modal__dialog">
      <div class="modal-content logout-modal__content">
        <div class="logout-modal__icon" aria-hidden="true">
          <i class="bi bi-box-arrow-right"></i>
        </div>
        <div class="modal-body text-center px-4 pt-3 pb-2">
          <p class="logout-modal__eyebrow mb-2">Puestify</p>
          <h2 :id="labelId" class="logout-modal__title">¿Cerrar sesión?</h2>
          <p class="logout-modal__text mb-0">
            Vas a salir de tu cuenta. Podés volver a ingresar cuando quieras.
          </p>
        </div>
        <div class="modal-footer logout-modal__actions">
          <button type="button" class="btn logout-modal__cancel" data-bs-dismiss="modal">
            Seguir trabajando
          </button>
          <button
            type="button"
            class="btn logout-modal__confirm"
            data-bs-dismiss="modal"
            @click="$emit('confirm')"
          >
            <i class="bi bi-box-arrow-right me-2" aria-hidden="true"></i>
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmLogoutModal',
  emits: ['confirm'],
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  computed: {
    labelId() {
      return `${this.modalId}-label`;
    },
  },
};
</script>

<style scoped>
.logout-modal__dialog {
  width: min(92vw, 440px);
  margin-left: auto;
  margin-right: auto;
}

.logout-modal__content {
  position: relative;
  padding: 1.15rem 1rem 1rem;
  overflow: hidden;
  border: 1px solid rgba(37, 99, 235, 0.12);
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.2);
}

.logout-modal__content::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, #2563eb, #60a5fa);
}

.logout-modal__icon {
  display: grid;
  place-items: center;
  width: 58px;
  height: 58px;
  margin: 0.35rem auto 0;
  border-radius: 18px;
  color: #2563eb;
  background: #eaf2ff;
  font-size: 1.55rem;
}

.logout-modal__eyebrow {
  color: #2563eb;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.logout-modal__title {
  margin-bottom: 0.55rem;
  color: #0f172a;
  font-size: 1.35rem;
  font-weight: 750;
}

.logout-modal__text {
  color: #64748b;
  font-size: 0.92rem;
  line-height: 1.5;
}

.logout-modal__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem;
  padding: 1.15rem 0.75rem 0.25rem;
  border: 0;
}

.logout-modal__actions .btn {
  min-height: 44px;
  border-radius: 999px;
  font-size: 0.88rem;
  font-weight: 650;
}

.logout-modal__cancel {
  border: 1px solid #dbe3ee;
  color: #334155;
  background: #fff;
}

.logout-modal__cancel:hover {
  border-color: #bfdbfe;
  color: #1d4ed8;
  background: #eff6ff;
}

.logout-modal__confirm {
  border: 1px solid #dc2626;
  color: #fff;
  background: #dc2626;
  box-shadow: 0 8px 18px rgba(220, 38, 38, 0.2);
}

.logout-modal__confirm:hover {
  border-color: #b91c1c;
  color: #fff;
  background: #b91c1c;
}

@media (max-width: 420px) {
  .logout-modal__actions {
    grid-template-columns: 1fr;
  }
}
</style>
